import React from 'react';
import Modal from '../../component/Inc/Modal';
import Upload from '../../component/Inc/Upload';

function PopTrainingNotice(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="com_input pop_training_notice">
      <h2 className="pop_tit">교사교육 공고 등록</h2>
      <div className="content_container scroll">
        <ul className="com_input_sec">
          <li className="tit_field">교사교육 공고명</li>
          <li className="input_field">
            <input type="text" className="input" placeholder="" />
          </li>
          <li className="tit_field">교육 선택</li>
          <li className="input_field">
            <div className="com_input_wrap ">
              <select className="select">
                <option value="선택">선택</option>
              </select>
            </div>
          </li>
          <li className="tit_field">교관 선택</li>
          <li className="input_field">
            <div className="com_input_wrap ">
              <select className="select">
                <option value="선택">선택</option>
              </select>
            </div>
          </li>
          <li className="tit_field">회차 / 시간 입력</li>
          <li className="input_field">
            <div className="com_input_wrap flex_row">
              <select className="select">
                <option value="15회">15회</option>
              </select>
              <select className="select">
                <option value="1회 3시간">1회 3시간</option>
              </select>
            </div>
          </li>
          <li className="tit_field">기간 입력</li>
          <li className="input_field">
            <div className="com_input_wrap flex_row">
              <input type="date" className="com_datepicker xs" placeholder="2022. 01. 01" />
              <span className="divider"> ~ </span>
              <input type="date" className="com_datepicker xs" placeholder="2022. 01. 01" />
            </div>
          </li>
          <li className="tit_field">등록 가능 인원</li>
          <li className="input_field">
            <input type="text" className="input" placeholder="" />
          </li>
          <li className="tit_field">요일 시간선택</li>
          <li className="input_field">
            <div className="com_input_wrap flex_row">
              <div className="com_check_date">
                <input type="checkbox" className="chk_date" id="mon" />
                <label htmlFor="mon">월</label>
                <input type="checkbox" className="chk_date" id="tue" />
                <label htmlFor="tue">화</label>
                <input type="checkbox" className="chk_date" id="wed" />
                <label htmlFor="wed">수</label>
                <input type="checkbox" className="chk_date" id="thu" />
                <label htmlFor="thu">목</label>
                <input type="checkbox" className="chk_date" id="fri" />
                <label htmlFor="fri">금</label>
                <input type="checkbox" className="chk_date" id="sat" />
                <label htmlFor="sat">토</label>
                <input type="checkbox" className="chk_date" id="sun" />
                <label htmlFor="sun">일</label>
              </div>
            </div>
          </li>
          <li className="input_field">
            <div className="com_input_wrap flex_row">
              <input type="date" className="com_datepicker xs" placeholder="2022. 01. 01" />
              <select className="select edit_width">
                <option value="선택">선택</option>
              </select>
              <select className="select edit_width">
                <option value="선택">선택</option>
              </select>
            </div>
          </li>
          <li className="tit_field">등록마감일</li>
          <li className="input_field">
            <div className="com_input_wrap flex_row gap">
              <span className="com_check_box">
                <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                <label htmlFor="chk010">없음</label>
              </span>
              <input type="date" className="com_datepicker xs" placeholder="2022. 01. 01" />
            </div>
          </li>
          <li className="input_field text_box">
            <div className="editor">
              교사교육 공고 입니다.
              <br />
              홍길동, 김길동, 최길동 3명 필수 참석입니다.
            </div>
          </li>

          <li>
            <div className="upload_wrap">
              <div className="com_input_upload">
                <Upload title="파일 등록" className="com_btn gray s wl" />
              </div>
              <ul className="file_list">
                <li>
                  <div className="com_input_upload">
                    <p className="file">
                      <span className="txt">File name.pdf</span>
                      <button type="button" className="btn_del_file" onClick={() => {}}></button>
                      <button type="button" className="btn_down" onClick={() => {}}></button>
                    </p>
                  </div>
                </li>
                <li>
                  <div className="com_input_upload">
                    <p className="file">
                      <span className="txt">File name.pdf</span>
                      <button type="button" className="btn_del_file" onClick={() => {}}></button>
                      <button type="button" className="btn_down" onClick={() => {}}></button>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </li>

          <li>
            <hr className="com_divider type_inner" />
          </li>
          <li className="tit_field">참석자 등록</li>
          <li className='input_field'>
            <div className="com_input_wrap flex_row gap">
              <select className="select edit_width">
                <option value="지점 선택">지점 선택</option>
              </select>
              <select className="select edit_width">
                <option value="과목 선택">과목 선택</option>
              </select>
              <span className="com_check_box">
                <input type="checkbox" name="chk" id="chk011" className="com_chk" />
                <label htmlFor="chk011">교육 예정자</label>
              </span>
            </div>
          </li>
          <li className='input_field'>
            <section className="com_board_search">
              <article className="search">
                <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input xs type_search" />
                <button className="com_btn gray ws xs icon_search"></button>
              </article>
            </section>
          </li>
          <li>
            <div className="subject_box">
              <span className="tit">대상자 등록</span>
              <div className="com_input_wrap flex_col">
                <div className="row">
                  <div className="value">
                    <span className="txt">홍길동103</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </div>
                  <div className="value">
                    <span className="txt">홍길동103</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </div>
                  <div className="value">
                    <span className="txt">홍길동103</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </div>
                </div>
                <div className="row">
                  <div className="value">
                    <span className="txt">홍길동103</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </div>
                  <div className="value">
                    <span className="txt">홍길동103</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </div>
                  <div className="value">
                    <span className="txt">홍길동103</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </div>
                </div>
                <div className="row">
                  <div className="value">
                    <span className="txt">홍길동103</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </div>
                  <div className="value">
                    <span className="txt">홍길동103</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </div>
                  <div className="value">
                    <span className="txt">홍길동103</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopTrainingNotice;
